<template>
  <div id="translate-container">
    <input type="checkbox" id="translate-checkbox" >
    <div id="translate-content">
      <label for="translate-checkbox">
        <svg
          width="25"
          height="25"
          style="margin-bottom: -3px"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 3H8.88L8 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V15C0 15.5304 0.210714 16.0391 0.585786 16.4142C0.960859 16.7893 1.46957 17 2 17H9L10 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V5C20 4.46957 19.7893 3.96086 19.4142 3.58579C19.0391 3.21071 18.5304 3 18 3V3ZM5.17 12.59C4.08526 12.59 3.04496 12.1591 2.27793 11.3921C1.51091 10.625 1.08 9.58474 1.08 8.5C1.08 7.41526 1.51091 6.37496 2.27793 5.60793C3.04496 4.84091 4.08526 4.41 5.17 4.41C6.21 4.41 7.16 4.78 7.91 5.5L8 5.54L6.75 6.72L6.69 6.67C6.4 6.4 5.91 6.08 5.17 6.08C3.86 6.08 2.79 7.17 2.79 8.5C2.79 9.83 3.86 10.92 5.17 10.92C6.54 10.92 7.13 10.05 7.29 9.46H5.08V7.91H9.03L9.04 8C9.08 8.19 9.09 8.38 9.09 8.59C9.09 10.94 7.5 12.59 5.17 12.59ZM11.2 10.88C11.53 11.5 11.94 12.06 12.39 12.58L11.85 13.11L11.2 10.88ZM11.97 10.12H11L10.67 9.08H14.66C14.66 9.08 14.32 10.39 13.1 11.82C12.58 11.2 12.21 10.59 11.97 10.12ZM19 18C19 18.2652 18.8946 18.5196 18.7071 18.7071C18.5196 18.8946 18.2652 19 18 19H11L13 17L12.19 14.23L13.11 13.31L15.79 16L16.5 15.27L13.81 12.59C14.71 11.56 15.41 10.34 15.73 9.08H17V8.04H13.36V7H12.32V8.04H10.36L9.18 4H18C18.2652 4 18.5196 4.10536 18.7071 4.29289C18.8946 4.48043 19 4.73478 19 5V18Z"
            fill="white"
          />
        </svg>
      </label>
      <div style="display: inline-block" id="google_translate_element" />
    </div>
  </div>
</template>

<script>
export default {
  name: "GoogleTranslatorButton",

  data: function () {
    return {};
  },

  computed: {},

  created() {
    const community = window.LayersPortal && window.LayersPortal.communityId;

    window.onload = function () {
      if (community === "fll-open-brazil") {
        document.getElementById("translate-container").style.display = "inline";
      }
    };
  },

  methods: {},
};
</script>

<style>
#translate-container {
  display: none;
  position: fixed;
  top: 58px;
  right: 16px;
  background: #4a90e2;
  padding: 10px 11px;
  border-radius: 50px;
  white-space: nowrap;
  z-index: 2;
}

#translate-checkbox {
  display: none;
}

#translate-content {
  width: 26px;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
}

#translate-container input:checked + #translate-content {
  width: auto;
}

#translate-container label {
  cursor: pointer;
}

/* Google Translate Customization */
#google_translate_element > div > div {
  border-radius: 20px;
  padding: 0 7px;
  border: 0;
  background: #fff;
}
#google_translate_element {
  margin: 0 5px 0 10px;
}
.skiptranslate {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/GoogleTranslatorButton.vue